module.exports = __webpack_public_path__ + "static/media/Hero.bc30f6e4.jpg";